// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Patient → Clinical → Medical History only.
 *
 * Materialize is prefixed to \`.emr-mz-dashboard\` and injected after page CSS.
 * \`.emr-mz-dashboard td, th { padding: 15px 5px }\` and
 * \`input[type=text]:not(.browser-default) { height: 3rem; margin: 0 0 8px;
 * box-sizing: content-box }\` otherwise produce ~60–70px Past Medical History
 * rows. These selectors are scoped to \`.medical-history-section\` and are
 * more specific than those Materialize rules so the compact 20px row wins
 * without changing Table Designer or other Clinical tabs.
 */

.emr-mz-dashboard .medical-history-section,
.medical-history-section {
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 16px;
  box-sizing: border-box;
}

.emr-mz-dashboard .medical-history-section *,
.emr-mz-dashboard .medical-history-section *::before,
.emr-mz-dashboard .medical-history-section *::after,
.medical-history-section *,
.medical-history-section *::before,
.medical-history-section *::after {
  box-sizing: border-box;
}

.emr-mz-dashboard .medical-history-section,
.medical-history-section,
.emr-mz-dashboard .medical-history-section h2,
.emr-mz-dashboard .medical-history-section h3,
.emr-mz-dashboard .medical-history-section p,
.emr-mz-dashboard .medical-history-section li,
.emr-mz-dashboard .medical-history-section label,
.emr-mz-dashboard .medical-history-section span,
.emr-mz-dashboard .medical-history-section button,
.medical-history-section h2,
.medical-history-section h3,
.medical-history-section p,
.medical-history-section li,
.medical-history-section label,
.medical-history-section span,
.medical-history-section button {
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 16px;
}

.emr-mz-dashboard .medical-history-section table.medical-history-table,
.medical-history-section table.medical-history-table {
  display: table !important;
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  position: static;
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 16px;
}

.emr-mz-dashboard .medical-history-section table.medical-history-table thead,
.medical-history-section table.medical-history-table thead {
  display: table-header-group !important;
  float: none;
  position: static;
}

.emr-mz-dashboard .medical-history-section table.medical-history-table tbody,
.medical-history-section table.medical-history-table tbody {
  display: table-row-group !important;
  float: none;
  position: static;
}

.emr-mz-dashboard .medical-history-section table.medical-history-table tr,
.medical-history-section table.medical-history-table tr {
  display: table-row !important;
  height: 20px;
}

.emr-mz-dashboard .medical-history-section table.medical-history-table th,
.emr-mz-dashboard .medical-history-section table.medical-history-table td,
.medical-history-section table.medical-history-table th,
.medical-history-section table.medical-history-table td {
  display: table-cell !important;
  height: 20px;
  min-height: 20px;
  max-height: 20px;
  padding: 2px 6px;
  padding-top: 2px;
  padding-bottom: 2px;
  line-height: 16px;
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  text-transform: none;
  vertical-align: middle;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.emr-mz-dashboard .medical-history-section table.medical-history-table th,
.medical-history-section table.medical-history-table th {
  font-weight: 600;
}

.emr-mz-dashboard .medical-history-section table.medical-history-table td[colspan],
.medical-history-section table.medical-history-table td[colspan] {
  height: auto;
  min-height: 20px;
  max-height: none;
  padding: 8px 6px;
  white-space: normal;
  overflow: visible;
  text-align: center;
}

/*
 * Controls must fit the 16px content box left after 2px + 2px cell padding.
 * Materialize pins inputs to 3rem / content-box / 8px bottom margin; kill
 * those here with enough specificity (and !important on geometry).
 */
.emr-mz-dashboard .medical-history-section table.medical-history-table input:not([type]),
.emr-mz-dashboard .medical-history-section table.medical-history-table input[type="text"]:not(.browser-default),
.emr-mz-dashboard .medical-history-section table.medical-history-table input[type="text"],
.emr-mz-dashboard .medical-history-section table.medical-history-table input[type="search"]:not(.browser-default),
.emr-mz-dashboard .medical-history-section table.medical-history-table input[type="search"],
.emr-mz-dashboard .medical-history-section table.medical-history-table select:not(.browser-default),
.emr-mz-dashboard .medical-history-section table.medical-history-table select,
.medical-history-section table.medical-history-table input,
.medical-history-section table.medical-history-table select {
  display: inline-block !important;
  appearance: auto !important;
  -webkit-appearance: auto !important;
  box-sizing: border-box !important;
  height: 16px !important;
  min-height: 0 !important;
  max-height: 16px !important;
  margin: 0 !important;
  padding: 0 4px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 2px !important;
  background: #fff !important;
  box-shadow: none !important;
  font-family: Arial, sans-serif !important;
  font-size: 16px !important;
  line-height: 16px !important;
  vertical-align: middle;
}

.emr-mz-dashboard .medical-history-section table.medical-history-table input:focus,
.emr-mz-dashboard .medical-history-section table.medical-history-table select:focus,
.medical-history-section table.medical-history-table input:focus,
.medical-history-section table.medical-history-table select:focus {
  outline: none;
  border-color: #1e79e8 !important;
}

.emr-mz-dashboard .medical-history-section .medical-history-onset-meta,
.medical-history-section .medical-history-onset-meta {
  display: none;
}

.emr-mz-dashboard .medical-history-section .medical-history-pl-btn,
.medical-history-section .medical-history-pl-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  max-width: 16px;
  max-height: 16px;
  padding: 0;
  margin: 0;
  border: 1px solid rgba(30, 121, 232, 0.4);
  background: transparent;
  color: #1e79e8;
  line-height: 16px;
}

.emr-mz-dashboard .medical-history-section .medical-history-pl-btn svg,
.emr-mz-dashboard .medical-history-section table.medical-history-table svg,
.medical-history-section .medical-history-pl-btn svg,
.medical-history-section table.medical-history-table svg {
  width: 12px;
  height: 12px;
}

.emr-mz-dashboard .medical-history-section .medical-history-search,
.emr-mz-dashboard .medical-history-section input.medical-history-search:not([type]),
.emr-mz-dashboard .medical-history-section input.medical-history-search[type="search"]:not(.browser-default),
.emr-mz-dashboard .medical-history-section input.medical-history-search[type="search"],
.medical-history-section .medical-history-search {
  box-sizing: border-box !important;
  height: 24px !important;
  min-height: 0 !important;
  max-height: 24px !important;
  margin: 0 !important;
  padding: 2px 8px 2px 28px !important;
  font-family: Arial, sans-serif !important;
  font-size: 16px !important;
  line-height: 16px !important;
}

.emr-mz-dashboard .medical-history-section .medical-history-toolbar-btn,
.medical-history-section .medical-history-toolbar-btn {
  height: 24px;
  min-height: 24px;
  padding-top: 2px;
  padding-bottom: 2px;
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 16px;
}

.emr-mz-dashboard .medical-history-section .medical-history-chip,
.medical-history-section .medical-history-chip {
  height: 20px;
  min-height: 20px;
  padding: 2px 8px;
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 16px;
}

.emr-mz-dashboard .medical-history-section .medical-history-side-list li,
.medical-history-section .medical-history-side-list li {
  min-height: 20px;
  line-height: 16px;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-medical-history.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF;;EAEE,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;;;;EAgBE,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,sCAAsC;EACtC,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;EACnC,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;;;EAIE,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;EAIE;AACF;;;;;;;;;EASE,gCAAgC;EAChC,2BAA2B;EAC3B,mCAAmC;EACnC,iCAAiC;EACjC,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,yCAAyC;EACzC,0BAA0B;EAC1B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;;;EAIE,aAAa;EACb,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,yCAAyC;EACzC,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,iCAAiC;EACjC,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,oCAAoC;EACpC,yCAAyC;EACzC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":["/*\n * Patient → Clinical → Medical History only.\n *\n * Materialize is prefixed to `.emr-mz-dashboard` and injected after page CSS.\n * `.emr-mz-dashboard td, th { padding: 15px 5px }` and\n * `input[type=text]:not(.browser-default) { height: 3rem; margin: 0 0 8px;\n * box-sizing: content-box }` otherwise produce ~60–70px Past Medical History\n * rows. These selectors are scoped to `.medical-history-section` and are\n * more specific than those Materialize rules so the compact 20px row wins\n * without changing Table Designer or other Clinical tabs.\n */\n\n.emr-mz-dashboard .medical-history-section,\n.medical-history-section {\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n  box-sizing: border-box;\n}\n\n.emr-mz-dashboard .medical-history-section *,\n.emr-mz-dashboard .medical-history-section *::before,\n.emr-mz-dashboard .medical-history-section *::after,\n.medical-history-section *,\n.medical-history-section *::before,\n.medical-history-section *::after {\n  box-sizing: border-box;\n}\n\n.emr-mz-dashboard .medical-history-section,\n.medical-history-section,\n.emr-mz-dashboard .medical-history-section h2,\n.emr-mz-dashboard .medical-history-section h3,\n.emr-mz-dashboard .medical-history-section p,\n.emr-mz-dashboard .medical-history-section li,\n.emr-mz-dashboard .medical-history-section label,\n.emr-mz-dashboard .medical-history-section span,\n.emr-mz-dashboard .medical-history-section button,\n.medical-history-section h2,\n.medical-history-section h3,\n.medical-history-section p,\n.medical-history-section li,\n.medical-history-section label,\n.medical-history-section span,\n.medical-history-section button {\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.emr-mz-dashboard .medical-history-section table.medical-history-table,\n.medical-history-section table.medical-history-table {\n  display: table !important;\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  position: static;\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.emr-mz-dashboard .medical-history-section table.medical-history-table thead,\n.medical-history-section table.medical-history-table thead {\n  display: table-header-group !important;\n  float: none;\n  position: static;\n}\n\n.emr-mz-dashboard .medical-history-section table.medical-history-table tbody,\n.medical-history-section table.medical-history-table tbody {\n  display: table-row-group !important;\n  float: none;\n  position: static;\n}\n\n.emr-mz-dashboard .medical-history-section table.medical-history-table tr,\n.medical-history-section table.medical-history-table tr {\n  display: table-row !important;\n  height: 20px;\n}\n\n.emr-mz-dashboard .medical-history-section table.medical-history-table th,\n.emr-mz-dashboard .medical-history-section table.medical-history-table td,\n.medical-history-section table.medical-history-table th,\n.medical-history-section table.medical-history-table td {\n  display: table-cell !important;\n  height: 20px;\n  min-height: 20px;\n  max-height: 20px;\n  padding: 2px 6px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  line-height: 16px;\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  letter-spacing: 0;\n  text-transform: none;\n  vertical-align: middle;\n  box-sizing: border-box;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.emr-mz-dashboard .medical-history-section table.medical-history-table th,\n.medical-history-section table.medical-history-table th {\n  font-weight: 600;\n}\n\n.emr-mz-dashboard .medical-history-section table.medical-history-table td[colspan],\n.medical-history-section table.medical-history-table td[colspan] {\n  height: auto;\n  min-height: 20px;\n  max-height: none;\n  padding: 8px 6px;\n  white-space: normal;\n  overflow: visible;\n  text-align: center;\n}\n\n/*\n * Controls must fit the 16px content box left after 2px + 2px cell padding.\n * Materialize pins inputs to 3rem / content-box / 8px bottom margin; kill\n * those here with enough specificity (and !important on geometry).\n */\n.emr-mz-dashboard .medical-history-section table.medical-history-table input:not([type]),\n.emr-mz-dashboard .medical-history-section table.medical-history-table input[type=\"text\"]:not(.browser-default),\n.emr-mz-dashboard .medical-history-section table.medical-history-table input[type=\"text\"],\n.emr-mz-dashboard .medical-history-section table.medical-history-table input[type=\"search\"]:not(.browser-default),\n.emr-mz-dashboard .medical-history-section table.medical-history-table input[type=\"search\"],\n.emr-mz-dashboard .medical-history-section table.medical-history-table select:not(.browser-default),\n.emr-mz-dashboard .medical-history-section table.medical-history-table select,\n.medical-history-section table.medical-history-table input,\n.medical-history-section table.medical-history-table select {\n  display: inline-block !important;\n  appearance: auto !important;\n  -webkit-appearance: auto !important;\n  box-sizing: border-box !important;\n  height: 16px !important;\n  min-height: 0 !important;\n  max-height: 16px !important;\n  margin: 0 !important;\n  padding: 0 4px !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 2px !important;\n  background: #fff !important;\n  box-shadow: none !important;\n  font-family: Arial, sans-serif !important;\n  font-size: 16px !important;\n  line-height: 16px !important;\n  vertical-align: middle;\n}\n\n.emr-mz-dashboard .medical-history-section table.medical-history-table input:focus,\n.emr-mz-dashboard .medical-history-section table.medical-history-table select:focus,\n.medical-history-section table.medical-history-table input:focus,\n.medical-history-section table.medical-history-table select:focus {\n  outline: none;\n  border-color: #1e79e8 !important;\n}\n\n.emr-mz-dashboard .medical-history-section .medical-history-onset-meta,\n.medical-history-section .medical-history-onset-meta {\n  display: none;\n}\n\n.emr-mz-dashboard .medical-history-section .medical-history-pl-btn,\n.medical-history-section .medical-history-pl-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  min-height: 16px;\n  max-width: 16px;\n  max-height: 16px;\n  padding: 0;\n  margin: 0;\n  border: 1px solid rgba(30, 121, 232, 0.4);\n  background: transparent;\n  color: #1e79e8;\n  line-height: 16px;\n}\n\n.emr-mz-dashboard .medical-history-section .medical-history-pl-btn svg,\n.emr-mz-dashboard .medical-history-section table.medical-history-table svg,\n.medical-history-section .medical-history-pl-btn svg,\n.medical-history-section table.medical-history-table svg {\n  width: 12px;\n  height: 12px;\n}\n\n.emr-mz-dashboard .medical-history-section .medical-history-search,\n.emr-mz-dashboard .medical-history-section input.medical-history-search:not([type]),\n.emr-mz-dashboard .medical-history-section input.medical-history-search[type=\"search\"]:not(.browser-default),\n.emr-mz-dashboard .medical-history-section input.medical-history-search[type=\"search\"],\n.medical-history-section .medical-history-search {\n  box-sizing: border-box !important;\n  height: 24px !important;\n  min-height: 0 !important;\n  max-height: 24px !important;\n  margin: 0 !important;\n  padding: 2px 8px 2px 28px !important;\n  font-family: Arial, sans-serif !important;\n  font-size: 16px !important;\n  line-height: 16px !important;\n}\n\n.emr-mz-dashboard .medical-history-section .medical-history-toolbar-btn,\n.medical-history-section .medical-history-toolbar-btn {\n  height: 24px;\n  min-height: 24px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.emr-mz-dashboard .medical-history-section .medical-history-chip,\n.medical-history-section .medical-history-chip {\n  height: 20px;\n  min-height: 20px;\n  padding: 2px 8px;\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.emr-mz-dashboard .medical-history-section .medical-history-side-list li,\n.medical-history-section .medical-history-side-list li {\n  min-height: 20px;\n  line-height: 16px;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
